import React from 'react';
import { LaosMarketSection } from '../components/LaosMarketSection';
export function LaosMarketPage() {
  return <div className="pt-20" data-id="element-782">
      <LaosMarketSection data-id="element-783" />
    </div>;
}